export const headers = [
  { content: "" },
  { content: "Plan" },
  { content: "Functional Area" },
  { content: "Total Inncodes" }
];
